<template>
  <widget-wrapper
    :id="configItem.chartId"
    :title="chartAttr.title"
    :subTitle="chartAttr.subtitle"
    :addtxt="chartAttr.addtxt"
    :info="chartAttr.info"
    :empty="empty"
    :loading="loadingbar"
    @ctrl="ctrlClick"
    class="default6"
  >
    <template v-slot:date-range> </template>
    <slot>
      <div class="widght-map">
        <c-scroll style="height: 100%">
          <div v-for="(item, index) in items.lists" :key="index" class="product">
            <div style="width: 100%; display: flex">
              <div class="text">
                <c-label :size="12" :color="$theme.COLOR.UI.UI01">
                  <div>{{ item.title }}({{ item.items.length }})</div>
                  <div class="sub-title">{{ item.desc }}</div>
                </c-label>
              </div>
              <div style="width: 100%; line-height: 18px; margin-top: 4px">
                <template v-for="(event, eventIndex) in item.items" :key="eventIndex">
                  <div
                    class="rect"
                    :class="bgClass(event)"
                    :style="{ cursor: isSettingMode ? 'default' : 'pointer' }"
                    @click="onClickPopup(event)"
                    v-lego-tooltip="event.productName"
                  ></div>
                </template>
              </div>
            </div>
          </div>
        </c-scroll>
        <div class="legend">
          <div
            v-for="(item, index) in items.types"
            :key="index"
            class="area"
            :style="'width:' + (items.width[index] + '%')"
          >
            <div class="item">
              <span class="icon-area"><div class="icon" :class="items.class[index]"></div></span>
              <span style="display: inline-block"
                ><c-label style="font-size: 10px; line-height: 18px; font-weight: normal">{{
                  $util.capitalize(item)
                }}</c-label></span
              >
            </div>
          </div>
        </div>
      </div>
    </slot>
  </widget-wrapper>
</template>
<script>
import widgetWrapper from '@/components/scpm/widgets/common/widgetWrapperScpm';
import widgetMixin from './widgetMixin';
import { getWidgetData } from '../serviceApi';

export default {
  name: 'EventMapWidget',
  components: { widgetWrapper },
  emits: ['popup'],
  mixins: [widgetMixin],
  props: {
    excludeResources: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    empty() {
      return this.$util.isEmpty(this.items.lists) || !this.isWidgetAuth;
    },
    bgClass() {
      return (event) => {
        let i = this.items.types.indexOf(event.latestEventLevel);
        if (i === -1) return 'bg_gray';
        else return this.items.class[i];
      };
    }
  },
  data() {
    return {
      items: {
        types: ['No Rule', 'NORMAL', 'INFORM', 'WARNING', 'FATAL'], // Event type
        class: ['bg_whiteGreen', 'bg_greenblue', 'bg_silver', 'bg_yellow', 'bg_watermelon'], // Event  별 class
        width: [20, 20, 20, 20, 20], // 이벤트 상태 라벨 가로 크기
        lists: [] // 상품별 이벤트 상세 목록
      }
    };
  },
  methods: {
    getData() {
      let param = {
        eventLevels: 'NORMAL,INFORM,WARNING,FATAL,NORULE',
        size: 0
      };
      if (this.searchDate) {
        param.queryStartDt = this.searchDate.queryStartDt;
        param.queryEndDt = this.searchDate.queryEndDt;
      }
      this.items.lists = [];
      getWidgetData('get', this.configItem.chartAttr.widget.api, param, this.header).then(
        (data) => {
          if (data instanceof Error) {
            return;
          }
          let result = [];
          data.contents.forEach((item) => {
            const code = item.productTypeCode;
            let product = result.find((item) => item.code === code);
            if (this.$util.isEmpty(product)) {
              result.push({
                title: item.productTypeName,
                desc: item.productDescription,
                code: code,
                items: []
              });
              product = result.find((item) => item.code === code);
            }
            product.items.push(item);
          });
          this.items.lists = result.filter((r) => !this.excludeResources.includes(r.code));
        }
      );
    },
    onClickPopup(item) {
      if (this.isSettingMode) return;
      let data = {
        id: 'monTargetDetail',
        param: {
          productTypeCode: item.productTypeCode,
          productId: item.productSq,
          eventId: '000000',
          searchDate: this.searchDate,
          productName: item.productName
        }
      };
      this.$emit('popup', data);
    }
  }
};
</script>

<style scoped lang="scss">
::v-deep .widget-body {
  padding: 0 0 20px 20px;
}
.widght-map {
  height: calc(100% - 12px);
  .product {
    margin-bottom: 16px;
    margin-right: 10px;
    overflow: auto;
    .text {
      width: 124px;
      flex: 0 0 auto;
      text-align: left;
      margin-right: 10px;
    }
  }
  .legend {
    display: flex;
    padding-right: 20px;
    .area {
      overflow: auto;
      .item {
        display: inline-flex;
        align-items: center;
        line-height: 18px;
        overflow: auto;
        margin-right: 6px;
        .icon-area {
          display: inline-block;
          margin-right: 4px;
        }
      }
    }
  }
}

.rect {
  width: 12px;
  height: 12px;
  margin: 0 2px 2px 0;
  border-radius: 2px;
  cursor: pointer;
  float: left;
}
.bg_greenblue {
  background-color: var(--greenblue) !important;
}
.bg_whiteGreen {
  background-color: #afe3cf !important;
}
.bg_watermelon {
  background-color: var(--watermelon) !important;
}
.bg_gray {
  background-color: #787c84 !important;
}
.bg_silver {
  background-color: #8a8f99 !important;
}
.bg_yellow {
  background-color: #ffd035 !important;
}
.icon {
  width: 11px;
  height: 11px;
  background-color: #787c84;
  border-radius: 6px;
}
::v-deep .simplebar-content {
  width: calc(100%);
}
.sub-title {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 10px;
}
:deep .simplebar-content-wrapper {
  background-color: #fff;
}
</style>
